import React from "react";
import {createUseStyles} from "react-jss";
import {SET_ACTIVE_ELEMENT, useScrollytellDispatch, useScrollyTellProps} from "./scrollytellContext";
import { addSection, insertSection } from "./service";
import { sectionTemplates } from "./sectionTemplates";
import { SectionTemplate } from "./SectionTemplate";

const useStyles = createUseStyles({
  sectionDialog: {
    display: "flex",
    flexWrap: "wrap",
    maxHeight: "100%",
    overflowY: "auto",
    maxWidth: "1054px",
    margin: "0 auto",
  },
});

export const SectionTemplatePicker = ({ onClose, insertIndex }) => {
  const classes = useStyles();
  const { story, onChange } = useScrollyTellProps();
  const dispatch = useScrollytellDispatch();

  const addTemplate = (templateId) => {
    const template = sectionTemplates.find((t) => t.templateId === templateId);
    if (template) {
      const total = story.sections?.length || 0;
      const targetIndex =
        typeof insertIndex === "number" && insertIndex >= 0 && insertIndex <= total
          ? insertIndex
          : total;
      onChange(
        insertSection(
          story,
          {
            ...template.section,
            order: targetIndex + 1,
          },
          targetIndex
        )
      );
      if (dispatch) {
        dispatch({ type: SET_ACTIVE_ELEMENT, activeSection: targetIndex });
      }
      setTimeout(() => {
        const el =
          document.getElementById(`section-${targetIndex + 1}`) ||
          document.querySelectorAll("#scrollytell-content section")?.[targetIndex];
        if (el?.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
      onClose();
    } else {
      console.warn("Unable to find template");
    }
  };

  return (
    <div className={classes.sectionDialog}>
      {sectionTemplates.map((template) => (
        <SectionTemplate
          key={`template-${template.templateId}`}
          template={template}
          onClick={() => addTemplate(template.templateId)}
        />
      ))}
    </div>
  );
};

